function shouldSubscribeToEvent(event, { whitelist, blacklist }) {
  // Either there is no white/black list or the given event is/isn't in the list
  const isWhitelistAllowed = !whitelist || whitelist.includes(event);
  const isBlacklistAllowed = !blacklist || !blacklist.includes(event);

  return isWhitelistAllowed && isBlacklistAllowed;
}

export default shouldSubscribeToEvent;
